import * as actionType from './WastemanagementAction';

const initialState = {
    list: [],
    message: '',
    apiStatus: false
}
const WasteManagementReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.Get_WASTEMANAGEMENT_DATA:
            return { ...state, message: "",  WasteManagementData: action.payload }
        case actionType.Get_WASTEMANAGEMENT_LIST:
            return { ...state, message: "",  WasteManagementList: action.payload }
        case actionType.API_CALL_STATUS:
            return { ...state, loading: action.payload.loading,apiStatus:action.payload.apiStatus, modalOpen: action.payload.modalOpen, message: action.payload.message}
                    
        default:
            return state
    }
}
export default WasteManagementReducer